import {
  Text,
  Tooltip,
  IconButton,
  Icons,
  Stack,
  Input,
  styled,
} from '@/theme/index';
import { UnclaimedMoneySummaryBarProps } from '../interfaces';

const StyledText = styled(Text)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 400,
  marginTop: theme.spacing(2),
}));

const InfoContainer = styled(Stack)(({ theme }) => ({
  justifyContent: 'space-between',
  marginTop: theme.spacing(3.5),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

const FilterContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'left',
  },
}));

export function UnclaimedMoneySummaryBar({
  firstName,
  lastName,
  totalResults,
  pages,
  filterValue,
  handleInputChange,
  isMobile,
}: UnclaimedMoneySummaryBarProps) {
  return (
    <InfoContainer>
      <FilterContainer>
        <StyledText variant="h1">
          {totalResults === 0 ? (
            <>
              <strong>0</strong> results for <strong>{firstName}</strong>{' '}
              <strong>{lastName}</strong>
            </>
          ) : (
            <>
              Showing <strong>{pages}</strong> of{' '}
              <strong>{totalResults}</strong> Results for{' '}
              <strong>{firstName}</strong> <strong>{lastName}</strong>
            </>
          )}
        </StyledText>
        <Tooltip
          title="Unclaimed property with the exact name and state you searched will appear first, similar matches will follow. We recommend reviewing the entire list since property often ends up unclaimed due to spelling errors."
          color="Info"
        >
          <IconButton data-cy="unclaimed-property-tooltip">
            <Icons.Help sx={{ fontSize: '1.25rem' }} />
          </IconButton>
        </Tooltip>
      </FilterContainer>
      <FilterContainer>
        {!isMobile && <Text variant="body1">Filter:</Text>}
        <Input
          onChange={handleInputChange}
          value={filterValue}
          placeholder="Search keywords like city, street, or business"
          sx={{ width: '362px' }}
        />
      </FilterContainer>
    </InfoContainer>
  );
}
